import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

(function($) {
    if ($('.hero-v4').length) {
        // Funzione di easing personalizzata con rallentamento molto pronunciato
        $.easing.easeOutQuart = function (x, t, b, c, d) {
            return -c * ((t=t/d-1)*t*t*t - 1) + b;
        };

        function animateNumber() {
            $('.number-title .digit').each(function(index) {
                var $digit = $(this);
                var value = parseInt($digit.data('value'));
                
                setTimeout(function() {
                    $digit.animate({top: -value * 10 + '%'}, {
                        duration: 100, // Aumentata significativamente la durata dell'animazione
                        easing: 'easeOutQuart', // Utilizzo della funzione di easing personalizzata
                        step: function(now) {
                            $digit.css('transform', 'translateY(' + now + '%)');
                        }
                    });
                }, index * 100);
            });
        }

        $(document).ready(function() {
            if (typeof ScrollTrigger !== 'undefined') {
                ScrollTrigger.create({
                    trigger: '.number-title',
                    start: 'top 80%',
                    onEnter: function() {
                        animateNumber();
                    },
                    once: true
                });
            } else {
                console.warn('ScrollTrigger non è caricato. L\'animazione del numero potrebbe non funzionare correttamente.');
                animateNumber();
            }
        });
    }
})(jQuery);
